// Figma values for the notifications popover (node 3002:4198) that have no
// equivalent in styles/theme.ts. Everything that does match a theme token
// (#f2f2f2 = back.infoCard, #ccc = border.default, #d1efff = back.searchComponent,
// #d37d4a = warning.main) is read from the theme instead.

/** Unread dot + Guardian badge. Not back.purple (#b594f2): the design uses #bc92f8. */
export const NOTIF_PURPLE = "#bc92f8";
/** Row hover (left frame of the design): a warm grey, full panel width. */
export const ROW_HOVER = "#e6e6e2";
/** Inset hairlines between rows and above the footer (0.5px in Figma, 1px here). */
export const DIVIDER = "#dedede";
/** Secondary copy (row body, empty-state subline). */
export const TEXT_MUTED = "#7f7f7f";
/** Timestamps. */
export const TEXT_TIME = "#999";

/** Horizontal inset shared by rows, dividers, the banner and the footer (36px in Figma). */
export const INSET_VAR = "--notif-inset";
export const inset = `var(${INSET_VAR})`;

/** Numbers/data face. index.html registers the Plex Mono files as 'IBM Mono'; Bold is 600. */
export const MONO_FONT = "'IBM Mono', monospace";
